import T from 'prop-types';
import React, { Component } from 'react';
import { TextInput } from '@acast/decibel';
import Field from 'shared/components/field';
import { formatTime, parseTime } from 'shared/helpers/time';
import { markerPropType } from '../../../../../../customPropTypes';
import { getMarkerEndpoints } from '../../../../../../shared/helpers/markers';

const VALID_TIME_REGEX = /^[0-9:]+(\.[0-9]+)?$/;

class PositionField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: formatTime(props.marker.start),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      value: formatTime(nextProps.marker.start),
    });
  }

  onChange = event => {
    this.setState({ value: event.target.value });
  };

  onBlur = () => {
    const { marker, markers, episodeDuration, onChange } = this.props;

    const [minValue, maxValue] = getMarkerEndpoints(markers, marker.id, episodeDuration);

    const { value } = this.state;
    let valueAsFloat = value.match(VALID_TIME_REGEX) ? parseTime(value) : marker.start;

    if (valueAsFloat < minValue) {
      valueAsFloat = minValue;
    }

    if (valueAsFloat > maxValue) {
      valueAsFloat = maxValue;
    }

    if (marker.start !== valueAsFloat) {
      onChange(valueAsFloat);
    }

    this.setState({ value: formatTime(valueAsFloat) });
  };

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onBlur();
    }
  };

  render() {
    return (
      <Field label="Position" name="start">
        <TextInput
          value={this.state.value}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onKeyPress={this.onKeyPress}
        />
      </Field>
    );
  }
}

PositionField.propTypes = {
  episodeDuration: T.number.isRequired,
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType).isRequired,
  onChange: T.func.isRequired,
};

export default PositionField;
